import CatchError from '@/components/system/CacthError';
import getI18nProps from '@/utils/i18/getI18nProps';

import PromotionsListView from '@/components/biz/promotions/List';
// export const runtime = 'experimental-edge';

const PromotionsList = () => {
  return <PromotionsListView />;
};

export async function getServerSideProps({ locale, params }) {
  return {
    props: {
      ...(await getI18nProps({ locale })),
    },
  };
}

export default CatchError(PromotionsList);
